import { render, staticRenderFns } from "./CommentAnswerKid.vue?vue&type=template&id=5a5607cc&scoped=true"
import script from "./CommentAnswerKid.vue?vue&type=script&lang=js"
export * from "./CommentAnswerKid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5607cc",
  null
  
)

export default component.exports